import type { AliasToken } from 'antd/es/theme/interface';
import type { ComponentTokenMap } from 'antd/es/theme/interface/components';

import { StyleConstantsEnum } from '@style/style.constants';

import { ColorEnum } from '@enum/style/color.enum';

type TypographyType = Partial<ComponentTokenMap['Typography']> & Partial<AliasToken>;

export const Typography: TypographyType = {
  fontFamily: StyleConstantsEnum.TextFontFamily,
  fontFamilyCode: StyleConstantsEnum.CodeFontFamily,
  fontSize: 16,
  colorText: ColorEnum.Black100,

  fontSizeHeading1: 72,
  fontSizeHeading2: 48,
  fontSizeHeading3: 34,
  fontSizeHeading4: 28,
  fontSizeHeading5: 22,

  lineHeightHeading1: 60 / 72,
  lineHeightHeading2: 1,
  lineHeightHeading3: 36 / 32,
  lineHeightHeading4: 32 / 28,
  lineHeightHeading5: 24 / 22,

  fontWeightStrong: 500,
  titleMarginTop: 0,
};
